import { createContext, useContext, useState, useEffect, useRef } from 'react';

const AdminAuthContext = createContext(null);

const ADMIN_IDLE_MS = 24 * 60 * 60 * 1000; // 24 hours

export const AdminAuthProvider = ({ children }) => {
  const [adminUser, setAdminUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('adminUser')); } catch { return null; }
  });
  const idleTimer = useRef(null);

  // Idle logout timer — only active while an admin is logged in
  useEffect(() => {
    if (!adminUser) return;

    const doIdleLogout = () => {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      setAdminUser(null);
      window.location.href = '/panel';
    };

    const reset = () => {
      clearTimeout(idleTimer.current);
      idleTimer.current = setTimeout(doIdleLogout, ADMIN_IDLE_MS);
    };

    const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'];
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();

    return () => {
      clearTimeout(idleTimer.current);
      events.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [adminUser]);

  const loginAdmin = (token, user) => {
    localStorage.setItem('adminToken', token);
    localStorage.setItem('adminUser', JSON.stringify(user));
    setAdminUser(user);
  };

  const logoutAdmin = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    setAdminUser(null);
  };

  return (
    <AdminAuthContext.Provider value={{ adminUser, loginAdmin, logoutAdmin }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
